(function () {
  'use strict';

  function toggleBtn(label, on) {
    if (on) {
      label.classList.add('active', 'chip--active', 'cl-filter-row--active');
    } else {
      label.classList.remove('active', 'chip--active', 'cl-filter-row--active');
    }
    var input = label.querySelector('input');
    if (input) input.checked = on;
  }

  function setupRadioGroup(containerId, allowClear) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('label').forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        var input = label.querySelector('input');
        var wasChecked = input && input.checked;
        container.querySelectorAll('label').forEach(function (l) { toggleBtn(l, false); });
        if (allowClear && wasChecked) {
          updateMobileResultCount();
          return;
        }
        toggleBtn(label, true);
        updateMobileResultCount();
      });
    });
  }

  function setupCheckboxGroup(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('label').forEach(function (label) {
      label.addEventListener('click', function (e) {
        e.preventDefault();
        var input = label.querySelector('input');
        toggleBtn(label, !input.checked);
        updateMobileResultCount();
      });
    });
  }

  function buildFormQuery(form) {
    var params = new URLSearchParams();
    form.querySelectorAll('input[type="hidden"]').forEach(function (input) {
      if (input.name && input.value) params.set(input.name, input.value);
    });
    form.querySelectorAll('input[name="difficulty"]:checked').forEach(function (input) {
      params.append('difficulty', input.value);
    });
    form.querySelectorAll('input[name="duration"]:checked').forEach(function (input) {
      params.append('duration', input.value);
    });
    var featured = form.querySelector('input[name="featured"]:checked');
    if (featured) params.set('featured', 'true');
    var status = form.querySelector('input[name="status"]:checked');
    if (status && status.value) params.set('status', status.value);
    form.querySelectorAll('input[name="categories"]:checked').forEach(function (input) {
      params.append('categories', input.value);
    });
    return params;
  }

  function updateMobileResultCount() {
    var form = document.getElementById('challengesFilterForm');
    var submitBtn = document.getElementById('coursesFilterSubmitBtn');
    if (!form || !submitBtn) return;

    var params = buildFormQuery(form);
    params.set('partial', 'count');

    fetch('/courses?' + params.toString(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || typeof data.total !== 'number') return;
        submitBtn.textContent = 'View ' + data.total + ' result' + (data.total === 1 ? '' : 's');
      })
      .catch(function () { /* ignore */ });
  }

  function initCoursesFilterForm() {
    var form = document.getElementById('challengesFilterForm');
    if (!form) return;

    setupCheckboxGroup('filterGroupDifficulty');
    setupCheckboxGroup('filterGroupDuration');
    setupCheckboxGroup('filterGroupFeatured');
    setupRadioGroup('filterGroupStatus', true);
    setupCheckboxGroup('filterGroupCategories');

    form.addEventListener('change', updateMobileResultCount);
    updateMobileResultCount();

    form.addEventListener('submit', function () {
      var sortHidden = form.querySelector('input[name="sort"]');
      if (sortHidden && sortHidden.value === 'newest') sortHidden.removeAttribute('name');

      form.querySelectorAll('input:not(:checked):not([type="hidden"])').forEach(function (i) {
        i.removeAttribute('name');
      });

      form.querySelectorAll('input[data-generated]').forEach(function (i) { i.remove(); });

      ['difficulty', 'duration', 'categories'].forEach(function (name) {
        var selected = Array.from(form.querySelectorAll('input[name="' + name + '"]:checked'))
          .map(function (i) { return i.value; });
        form.querySelectorAll('input[name="' + name + '"]').forEach(function (i) { i.removeAttribute('name'); });
        if (selected.length) {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = name;
          hidden.value = selected.join(',');
          hidden.setAttribute('data-generated', '1');
          form.appendChild(hidden);
        }
      });
    });
  }

  function setGridLoading(on) {
    var cards = document.getElementById('course_cards');
    if (!cards) return;
    if (on) {
      cards.dataset.loadingMinHeight = String(cards.offsetHeight);
      cards.style.minHeight = cards.dataset.loadingMinHeight + 'px';
    } else {
      cards.style.minHeight = '';
      delete cards.dataset.loadingMinHeight;
    }
    cards.classList.toggle('cl-grid-col--loading', on);
  }

  function parseUrlListParam(params, name) {
    var values = [];
    params.getAll(name).forEach(function (value) {
      String(value).split(',').forEach(function (part) {
        part = part.trim();
        if (part) values.push(part);
      });
    });
    return values;
  }

  function syncMobileFilterModalFromUrl(url) {
    var form = document.getElementById('challengesFilterForm');
    if (!form) return;

    var params;
    try {
      params = new URLSearchParams(new URL(url, window.location.origin).search);
    } catch (err) {
      return;
    }

    var difficulties = parseUrlListParam(params, 'difficulty');
    var durations = parseUrlListParam(params, 'duration');
    var categories = parseUrlListParam(params, 'categories');
    var featured = params.get('featured') === 'true';
    var status = params.get('status') || '';

    form.querySelectorAll('input[name="difficulty"]').forEach(function (input) {
      toggleBtn(input.closest('label'), difficulties.includes(input.value));
    });
    form.querySelectorAll('input[name="duration"]').forEach(function (input) {
      toggleBtn(input.closest('label'), durations.includes(input.value));
    });
    form.querySelectorAll('input[name="categories"]').forEach(function (input) {
      toggleBtn(input.closest('label'), categories.includes(input.value));
    });
    form.querySelectorAll('input[name="featured"]').forEach(function (input) {
      toggleBtn(input.closest('label'), featured);
    });
    form.querySelectorAll('input[name="status"]').forEach(function (input) {
      toggleBtn(input.closest('label'), status === input.value);
    });

    updateMobileResultCount();
  }

  function applyListingPartial(html, syncUrl) {
    var container = document.createElement('div');
    container.innerHTML = html.trim();

    var nextSidebar = container.querySelector('#coursesFilterSidebarPartial');
    var sidebarHost = document.querySelector('.cl-sidebar');
    if (nextSidebar && sidebarHost) {
      sidebarHost.innerHTML = nextSidebar.innerHTML;
    }

    ['coursesResultsToolbar', 'course_cards'].forEach(function (id) {
      var next = container.querySelector('#' + id);
      var current = document.getElementById(id);
      if (next && current) {
        current.replaceWith(next);
      }
    });

    var nextPagination = container.querySelector('#coursesPagination');
    var currentPagination = document.getElementById('coursesPagination');
    if (nextPagination && currentPagination) {
      currentPagination.replaceWith(nextPagination);
    } else if (nextPagination && !currentPagination) {
      var gridCol = document.getElementById('coursesGridCol');
      if (gridCol) gridCol.appendChild(nextPagination);
    } else if (!nextPagination && currentPagination) {
      currentPagination.remove();
    }

    if (syncUrl) syncMobileFilterModalFromUrl(syncUrl);
  }

  function updateResultCount(total) {
    var el = document.getElementById('coursesResultCount');
    if (!el || typeof total !== 'number') return;
    var strong = el.querySelector('strong');
    if (strong) strong.textContent = String(total);
    var label = total === 1 ? 'result' : 'results';
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && /\bresults?\b/.test(node.textContent)) {
        node.textContent = node.textContent.replace(/\bresults?\b/, label);
        break;
      }
    }
  }

  function navigateWithAjax(url, pushState) {
    if (!window.fetch || !document.getElementById('coursesGridCol')) {
      window.location.href = url;
      return;
    }

    var gridUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'partial=grid';
    setGridLoading(true);

    fetch(gridUrl, {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('grid fetch failed');
        return res.text();
      })
      .then(function (html) {
        applyListingPartial(html, url);
        if (pushState) window.history.pushState({ coursesListing: true }, '', url);
        return fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'partial=count', {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
        });
      })
      .then(function (res) { return res && res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && typeof data.total === 'number') updateResultCount(data.total);
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        setGridLoading(false);
      });
  }

  function initCoursesAjaxFilters() {
    var sortSelect = document.getElementById('coursesSortSelect');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        navigateWithAjax(sortSelect.value, true);
      });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-courses-filter-link]');
      if (!link || !link.href || link.getAttribute('href') === '#') return;
      if (link.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      if (window.matchMedia('(max-width: 991.98px)').matches) return;
      e.preventDefault();
      navigateWithAjax(link.href, true);
    });

    window.addEventListener('popstate', function () {
      if (!document.getElementById('coursesGridCol')) return;
      navigateWithAjax(window.location.pathname + window.location.search, false);
    });
  }

  function init() {
    initCoursesFilterForm();
    initCoursesAjaxFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
